import { OcrAccountsAggregateApi } from "@/features/accounts/ocr/services/ocraccounts-aggregate-api";
import { OcrAccountsAggregateRequestModel } from "@/features/accounts/ocr/services/ocraccounts-aggregate-model";

/// OCR明細取込処理
export class OcrAccountsAggregateService {
  private ocrAccountsAggregateApi = new OcrAccountsAggregateApi();

  /**
   * OCR明細取込API実行
   */
  public async OcrAccountsAggregate(param: OcrAccountsAggregateRequestModel) {
    return await this.ocrAccountsAggregateApi.OcrAccountsAggregate(param);
  }
}
